import React from 'react';
import Card from '../components/ui/Card.jsx';

export default function Placeholder({ title = 'Coming soon' }) {
  return (
    <div className="page">
      <div className="page-header">
        <h1>{title}</h1>
        <p className="subtle">This section is being implemented in the next iteration.</p>
      </div>
      <div className="grid two">
        <Card title="Planned Features">
          <ul className="list">
            <li>Advanced data workflows</li>
            <li>Bulk actions and filters</li>
            <li>Role-based approvals</li>
          </ul>
        </Card>
        <Card title="Status">
          <div className="status-pill">In Progress</div>
          <p className="subtle">Premium UI and API scaffolding are in place.</p>
        </Card>
      </div>
    </div>
  );
}
